export default "__VITE_ASSET__CQp6fWWZ__"